module.exports = __webpack_public_path__ + "img/poly-12.e45b936c.png";